<!-- @format -->

@if (options) {
  @if (options.length === 1 && !options[0].disabled) {
    <sis-description-list>
      <dl>
        <ng-template #listItem>
          <dt>{{ "ENTITY_NAMES.CourseUnitEnrolmentRight" | translate }}</dt>
          <dd
            >{{ options[0].label }}
            @if (options[0].info) {
              ({{ options[0].info }})
            }
          </dd>
        </ng-template>
      </dl>
    </sis-description-list>
  } @else {
    <label [for]="id" [class]="getLabelState(control)">
      {{ "ENTITY_NAMES.CourseUnitEnrolmentRight" | translate }}
    </label>
    <sis-dropdown-select [options]="options" [control]="control" [id]="id"> </sis-dropdown-select>
  }
}
